<h3 class="ui primary header">
  {{ modal.context.currentValue ? "Update " : "Update " }} Password
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="ui vertical basic segment">
  <div *ngIf="success || error" style="margin: 10px 0;">
    <sui-message class="success" *ngIf="success">
      <div class="header">
        {{ success }}
      </div>
    </sui-message>
    <sui-message class="warning" *ngIf="error">
      <div class="header">
        {{ error | json }}
      </div>
    </sui-message>
  </div>
  <div class="content">
    <div class="scroll-wrapper ui basic segment">
      <form
        class="ui form"
        [formGroup]="passwordUpdateForm"
        name="createProcurementItem"
      >

      <div class="msg-text">Please enter your current password to change your password 
        and make sure it's at least 8 characters including a number and a letter</div>
        <!-- First Name -->
        <div class="required field" [class.error]="isFieldValid('oldPassword')">
          <label>Old Password</label>
          <input type="text" formControlName="oldPassword" placeholder="Old Password">
        </div>
        <app-field-error
          [displayError]="isFieldValid('oldPassword')"
          errorMsg="Enter Old Password"
        ></app-field-error>

        <!-- last Name -->
        <div class="required field" [class.error]="isFieldValid('newPassword')">
          <label>New Password</label>
          <input type="text" formControlName="newPassword" placeholder="New Password">
        </div>
        <app-field-error
          [displayError]="isFieldValid('newPassword')"
          errorMsg="Enter New password"
        ></app-field-error>

        <!-- Email Address -->
        <div class="required field" [class.error]="isFieldValid('confirmNewPassword')">
          <label>Confirm New Password</label>
          <input type="text" formControlName="confirmNewPassword" placeholder="Confirm New Password">
        </div>
        <app-field-error
          [displayError]="isFieldValid('confirmNewPassword')"
          errorMsg="Confirm New Password"
        ></app-field-error>
      </form>
    </div>
  </div>
</div>
<div class="actions" style="border: none">
  <!-- Cancel Button -->
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>

  <!-- Confirm Button -->
  <button
    class="ui primary button"
    [disabled]="passwordUpdateForm.invalid || pending"
    (click)="save()"
    autofocus
  >
    Update Password
  </button>
</div>